var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"current_site"},[_c('img',{attrs:{"src":require("../assets/icons/sites_white.svg")}}),_c('span',[_vm._v(_vm._s(_vm.unit.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }